<template>
    <div ref="list"
         role="listbox"
         tabindex="0"
         :aria-labelledby="labelId"
         @blur="reset(value)"
         @keydown="handleKeydown($event)"
         :aria-activedescendant="activeDescendant"
    >
        <p :id="labelId" class="news-filter-select__options-label">
            {{ label }}:
        </p>
        <button v-for="(option) in options"
                :id="optionId(option)"
                :key="option.value"
                ref="option"
                :class="{selected: isSelected(option)}"
                class="news-filter-select__option secondary-text text-uppercase d-block w-100 py-1 text-md-left font-family-alternative text-uppercase fs-h2"
                type="button"
                role="option"
                tabindex="-1"
                :aria-selected="isSelected(option) ? 'true' : 'false'"
                @click="$emit('select', option)"
        >
            {{ option.label }}
        </button>
    </div>
</template>

<script>
    let UNIQUE_ID = 0;

    export default {
        props: {
            options: {
                type: Array,
                required: true,
            },
            value: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                uniqueId: UNIQUE_ID++,
                currentOption: this.getOption(this.getValueIndex(this.value)),
            };
        },
        computed: {
            labelId () {
                return `news-filter-${this.uniqueId}`;
            },
            activeDescendant () {
                let index = this.optionId(this.currentOption);
                return index;
            },
        },
        watch: {
            value (value) {
                this.reset(value);
            },
        },
        methods: {
            reset (value) {
                this.currentOption = this.getOption(this.getValueIndex(value));
            },
            optionId (option) {
                return `news-filter-${this.uniqueId}--option-${option.value}`;
            },
            isSelected (option) {
                return option.value === this.currentOption.value;
            },
            getOption (index) {
                const len          = this.options.length;
                const wrappedIndex = (len + index) % len;
                return this.options[wrappedIndex];
            },
            getValueIndex (value) {
                return this.options.findIndex((o) => o.value === value);
            },
            handleKeydown (e) {
                const currentValueIndex = this.options.indexOf(this.currentOption);
                switch (e.key) {
                    case 'ArrowDown':
                        this.currentOption = this.getOption(currentValueIndex + 1);
                        e.preventDefault();
                        break;
                    case 'ArrowUp':
                        this.currentOption = this.getOption(currentValueIndex - 1);
                        e.preventDefault();
                        break;
                    case 'Home':
                        this.currentOption = this.getOption(0);
                        break;
                    case 'End':
                        this.currentOption = this.getOption(this.options.length - 1);
                        break;
                    case 'Enter':
                        this.$emit('select', this.currentOption);
                        break;
                }
            },
        },
    };
</script>
